
















import Vue from 'vue';
import Vuex from 'vuex';
import { Component, Prop } from "vue-property-decorator";
Vue.use(Vuex);

/*
    * Component's properties and events
*/
@Component({
     components: {}
})

export default class TitleComponents extends Vue {
    /*
        *  A component�s settings option must be a function, so that each instance can maintain an independent copy of the returned data object.
    */
    get settings() {
        // @ts-ignore
        return this.$store.state[this.$options.parent.fileName || this.$options.parent.$parent.fileName];
    }
}
